import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
let myvid: any;

@Component({
  selector: 'app-video-player',
  templateUrl: './video-player.component.html',
  styleUrls: ['./video-player.component.css'],
})
export class VideoPlayerComponent implements OnInit {
  @Input() page: any;
  @Input() event_id: any;
  @Input() first_video: any;
  @Input() second_video: any;
  @Output() durationVideoTime = new EventEmitter<any>();
  videoEnd = false;
  firstVideoFlag = true;
  secondVideoFlag = true;

  constructor() {}
  ngOnInit(): void {
    myvid = document.getElementById('videoBG') as HTMLMediaElement;
    myvid.controls = false;
    myvid.muted = false;
    myvid.load();
    const promise = myvid.play();
    if (promise !== undefined) {
      promise.then(_ => {
        myvid.webkitRequestFullscreen();
      }).catch(error => {
        setTimeout(()=>{
          console.log('Autoplay not started' + error);
          if(error){
            this.completeMotionGraphics(myvid);
  
          }
        }, 2000)
  
      /*  if (error.toString().includes('user didn\'t interact with the document first')) {
         this.completeMotionGraphics(myvid);
        } else {
          myvid.webkitRequestFullscreen();
        }*/
      });
    }

  }

  myFunction() {
    if (this.firstVideoFlag){
      myvid = document.getElementById('videoBG') as HTMLMediaElement;
      this.startSecondVideo(myvid);
    }
    else if (this.secondVideoFlag){
      this.completeMotionGraphics(myvid);
    }
  }

  private startSecondVideo(videoPlayer: any): void {
    videoPlayer.setAttribute('src', this.second_video);
    videoPlayer.load();
    const promise = videoPlayer.play();
    if (promise !== undefined) {
      promise.then(_ => {
        myvid.webkitRequestFullscreen();
      }).catch(error => {
        console.log('Autoplay not started' + error);
        if (error.toString().includes('user didn\'t interact with the document first')) {
          this.completeMotionGraphics(myvid);
        } else {
          myvid.webkitRequestFullscreen();
        }
      });
    }
    this.firstVideoFlag = false;
  }

  private completeMotionGraphics(videoPlayer: any): void {
    console.log('test')
    localStorage.setItem("motionGraphics"+this.event_id, "done");
    videoPlayer.webkitExitFullscreen();
    this.videoEnd = true;
    this.durationVideoTime.emit(this.videoEnd);
    this.secondVideoFlag = false;
    
  }
}
